var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c("v-date-picker", {
        staticClass: "no-print",
        attrs: { landscape: "" },
        nativeOn: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.updateField()
          },
        },
        model: {
          value: _vm.input,
          callback: function ($$v) {
            _vm.input = $$v
          },
          expression: "input",
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "print-only" }, [
        _vm._v(_vm._s(this.field.value)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }